export async function checkAdmin(user) {
    try {
        const response = await fetch(`${process.env.REACT_APP_OPENAI_SERVER_EXPRESS}/auth/check-admin`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ user }), 
        });

        if (!response.ok) {
            const error = await response.json();
            console.error('Erro na resposta do servidor:', error);
            throw new Error(error.error || 'Erro ao verificar permissões.');
        }

        const data = await response.json();
        return data.isAdmin; 
    } catch (error) {
        console.error('Erro ao verificar permissões:', error);
        return false; 
    }
}
